import { useEffect } from 'react';

/**
 * Hook to control footer visibility using CSS variables
 * @param {boolean} isVisible - Whether the footer should be visible (default: true)
 */
const useFooterVisibility = (isVisible = true) => {
  useEffect(() => {
    if (!isVisible) {
      // Hide footer by setting CSS variable
      document.documentElement.style.setProperty('--footer-display', 'none');
    } else {
      // Show footer by removing CSS variable (falls back to default)
      document.documentElement.style.removeProperty('--footer-display');
    }

    // Cleanup on unmount or when visibility changes
    return () => {
      document.documentElement.style.removeProperty('--footer-display');
    };
  }, [isVisible]);
};

export default useFooterVisibility;